import NOA_FIELDS_JSON from "./noaFormFields";
import CONTRACT_FIELDS_JSON from "./contractFormFields";

export const noaDefaultFor = (bankName, borrowerName, coborrowerName) => {
  const base = {};
  NOA_FIELDS_JSON.forEach((f) => {
    if (f.name) base[f.name] = f.value ?? "";
  });
  return {
    ...base,
    noa_received: "Yes",
    financier_id: bankName,
    primary_borrower_name: borrowerName || "",
    co_borrower_name: coborrowerName || "",
  };
};

export const contractDefaultFor = () => {
  const base = {};
  CONTRACT_FIELDS_JSON.forEach((f) => {
    if (f.name) base[f.name] = f.value ?? "";
  });
  return { ...base, contract_signing_received: "Yes" };
};
